import { Component } from '@angular/core';

@Component({
  template: '<h2>Page not found</h2>'
})
export class PageNotFoundComponent { }



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/page-not-found/page-not-found.component.ts